import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Payment from './payment/Payment';
import Conditions from './condition';
import Home from './Home';

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/condition" element={<Conditions />} />
          {/* <Route path="/payment" element={<Payment />} /> */}
        </Routes>
      </Router>
    </div>

  );
}

export default App;
